// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "../../../../../../node_modules/rescript/lib/es6/js_array.js";
import * as AssetStore$PorterinFeature from "../../../ui/assets/AssetStore.mjs";
import * as OrderHistoryStore$PorterinFeature from "../domian/store/OrderHistoryStore.mjs";
import * as OrderHistoryHelper$PorterinFeature from "../domian/helpers/OrderHistoryHelper.mjs";

function getSeoContent(param) {
  return {
          title: OrderHistoryStore$PorterinFeature.meta_title,
          meta_description: OrderHistoryStore$PorterinFeature.meta_description,
          local_data: /* [] */0,
          image: {
            path: OrderHistoryHelper$PorterinFeature.default_image_src,
            alt_text: OrderHistoryHelper$PorterinFeature.default_image_alt
          },
          is_no_index: false
        };
}

function checkOrderType(order_type) {
  return order_type === /* OnDemand */0;
}

function createVm(data, mobile) {
  return Js_array.filter((function (live_order) {
                if (live_order.order_status === /* Searching */0 || live_order.order_status === /* Confirmed */1 || live_order.order_status === /* Live */2) {
                  return live_order._type === /* OnDemand */0;
                } else {
                  return false;
                }
              }), data.live_orders);
}

var default_vehicle_icon = {
  src: "https://dom-content-vault-prod-cdn-assets.porter.in/default_truck_icon_db49a278d0/default_truck_icon_db49a278d0.svg",
  width: 54.0,
  height: 54.0,
  alt: "Default Vehicle Icon"
};

function iconUrl(order) {
  var val = order.service_details;
  if (val !== undefined) {
    return {
            src: val.icon_url,
            width: 56.0,
            height: 40.0,
            alt: "Vehicle Icon"
          };
  } else {
    return default_vehicle_icon;
  }
}

function title(order) {
  var val = order.service_details;
  if (val !== undefined) {
    return val.name;
  } else {
    return "Vehicle";
  }
}

function contact(contact$1) {
  if (contact$1 !== undefined) {
    return contact$1;
  } else {
    return {
            name: "Sender",
            mobile: ""
          };
  }
}

function source(order) {
  var val = order.route_details.source;
  if (val !== undefined) {
    return {
            address: val.place.address,
            contact: contact(val.contact)
          };
  } else {
    return {
            address: "",
            contact: {
              name: "Sender",
              mobile: ""
            }
          };
  }
}

function destination(order) {
  var val = order.route_details.destination;
  if (val !== undefined) {
    return {
            address: val.place.address,
            contact: contact(val.contact)
          };
  } else {
    return {
            address: "",
            contact: {
              name: "Receiver",
              mobile: ""
            }
          };
  }
}

var address_drop_icon = {
  src: AssetStore$PorterinFeature.dropPin,
  width: 12.0,
  height: 15.0,
  alt: "Drop Address Icon"
};

var error_fetching = {
  text: OrderHistoryStore$PorterinFeature.error_fetching_text,
  sub_text: OrderHistoryStore$PorterinFeature.error_fetching_sub_text
};

var commonAssetPath = "/assets/icons/common/booking-flow/";

var left_arrow = {
  src: "https://dom-content-vault-prod-cdn-assets.porter.in/arrow_left_default_59393211ba/arrow_left_default_59393211ba.svg",
  width: 24.0,
  height: 24.0,
  alt: "Back Icon"
};

var error_something_went_wrong = {
  src: "https://dom-content-vault-prod-cdn-assets.porter.in/error_ef88199d3d/error_ef88199d3d.svg",
  width: 150.0,
  height: 150.0,
  alt: "Map Pin"
};

export {
  commonAssetPath ,
  getSeoContent ,
  left_arrow ,
  error_something_went_wrong ,
  checkOrderType ,
  createVm ,
  default_vehicle_icon ,
  iconUrl ,
  title ,
  contact ,
  source ,
  destination ,
  address_drop_icon ,
  error_fetching ,
}
/* No side effect */
